<template>
  <div class="w-full">
    <DatatableReportV3
      id="customers-table"
      ref="customer_table"
      title="Customers"
      :config="config"
      :source="source"
      :filters="filters"
      no-download
    >
      <template #actions>
        <div class="flex flex-wrap gap-3">
          <MergeAccountsButton v-if="mergeEnabled" />
          <SeraButton
            icon="fa fa-plus fa-fw"
            text="Add Customer"
            class="whitespace-nowrap"
            @click="handleClick"
          />
        </div>
      </template>
    </DatatableReportV3>
    <ConfirmArchiveModal
      :open="confirmArchiveModalOpen"
      @archive-confirmed="handleArchiveConfirmed"
      @close="confirmArchiveModalOpen = false"
    />
    <ConfirmUnarchiveModal
      :open="confirmUnarchiveModalOpen"
      @close="confirmUnarchiveModalOpen = false"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import SeraButton from "@/components/Button.vue";
import ConfirmArchiveModal from "@/Customer/ConfirmArchiveModal.vue";
import ConfirmUnarchiveModal from "@/Customer/ConfirmUnarchiveModal.vue";
import MergeAccountsButton from "@/Customer/MergeAccountsButton.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";
import store from "@/vuex/store";
import CustomerActionsMenu from "./CustomerActionsMenu.vue";

export default {
  components: {
    ConfirmArchiveModal,
    ConfirmUnarchiveModal,
    DatatableReportV3,
    MergeAccountsButton,
    SeraButton
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mergeEnabled: window.currentTenant.merge_tools_enabled,
      config: {
        pageLength: 25,
        order: [[1, "asc"]],
        columns: [
          { data: "id", orderable: false, searchable: false },
          { data: "name" },
          { data: "address", orderable: false, className: "address-field" },
          { data: "email", className: "email-field" },
          { data: "phone", className: "phone-field" },
          { data: "tags", title: "Tags", orderable: false },
          { data: "date_added", title: "Date Added", searchable: false },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "customer-action-menu-vue",
            component: CustomerActionsMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      },
      confirmArchiveModalOpen: false,
      confirmUnarchiveModalOpen: false,
      archiveCallback: () => {}
    };
  },
  mounted() {
    EventBus.$on("refresh-customer-table", this.refreshData);
    EventBus.$on("confirm-archive", this.handleConfirmArchive);
    EventBus.$on("confirm-unarchive", this.handleConfirmUnarchive);
  },
  beforeUnmount() {
    EventBus.$off("refresh-customer-table", this.refreshData);
    EventBus.$off("confirm-archive", this.handleConfirmArchive);
    EventBus.$off("confirm-unarchive", this.handleConfirmUnarchive);
  },
  methods: {
    refreshData() {
      this.$refs.customer_table.refreshTable();
    },
    handleClick() {
      if (this.$router) {
        this.$router.push("/customers/new");
      } else {
        window.location.href = this.userCreatePath();
      }
    },
    handleConfirmArchive(archiveCallback) {
      this.archiveCallback = archiveCallback;
      this.confirmArchiveModalOpen = true;
    },
    handleConfirmUnarchive() {
      this.confirmUnarchiveModalOpen = true;
    },
    handleArchiveConfirmed() {
      this.confirmArchiveModalOpen = false;
      this.archiveCallback();
    }
  }
};
</script>

<style lang="scss" scoped></style>
